import { axios } from "../../../../../utils/settings";
import { createActionErrorCapture, errorEnvelope } from '../../../../../utils/sentryUtils';
import { getToken, getTokenHeader } from "../../../../Common/Token";
import { annualTripDetailsUrl } from "../urls";


const captureActionError = createActionErrorCapture('benefits');
export const getAnnualTripDetails = async (manufacturer_id, company_esi_id) => {
  try {
    const token = await getToken();
    const { data } = await axios.get(
      `${annualTripDetailsUrl()}?manufacturer_id=${manufacturer_id}&company_esi_id=${company_esi_id}`,
      getTokenHeader(token),
    );
    return data;
  } catch (err) {
    captureActionError(err, 'getAnnualTripDetails');
    return errorEnvelope(err, 'Something went wrong. Please try again.');
  }
};
